import { config } from '@/config';

export const appRouterBasename = config.routerBasename;

export default appRouterBasename;
